module.exports = __webpack_public_path__ + "static/media/ticket.1df4115d.svg";